import PricingTable from './pricingTable'
import { publicPath } from '../../template.config'

if (jQuery) {
  console.log("jquery is loaded");
} else {
  console.log("Not loaded");
}

jQuery(function ($) {
  //
  // Find page title and add it to the header gradient strip
  //
  function pageTitle() {
    const pageTitle = $('main h1:first')
    const eventTitle = $('.tn-prod-season-header__title')
    if ($('.tn-prod-season-header__title').length) {
      $('.c-sitename h1').html(eventTitle.html())
      eventTitle.addClass('sr-only')
    } else {
      $('.c-sitename h1').html(pageTitle.html())
      pageTitle.addClass('sr-only')
      $('#tn-page-heading').remove()
    }
  }
  pageTitle()

  // // Put shopping cart icon before text
  // $('.tn-cart-link .tn-link .tn-icon').each(function () {
  //   $(this).insertBefore($(this).prev('.tn-text'))
  // })

  // Add id to main for skip to content button
  $('main').attr('id', 'main');

  //
  // Append plus and minus symbols to dropdown selects
  //
  let zone = 0

  const inputZone = $('.tn-ticket-selector__zone-selector input[type=radio].tn-ticket-selector__input-zone')

// Fix to redirect incorrectly printed posters - check with LDN comms - could be removed if printed stock has run out.
  
if ($(location).prop('href').startsWith("https://my.sciencemuseum.org.uk/418555/418556"))
{
  window.location.href = "https://www.sciencemuseum.org.uk/about-us/support-us?utm_source=Onsite+Table+Talker&utm_medium=QR+Code&utm_campaign=L+DG%3A+Regular+Giving+Table+Talker+QR+Code%2C+19.3.26"
}

// Adding copy explaining pwd reqs before user tries
  $('label[for="PatronRegister_Password"]').append("<div><p style='font-size: 12px; font-weight: normal;'><i>Password must be at least 12 characters long and contain at least one number, one special character, and both uppercase and lowercase letters.</i></p></div>");
    
  // function addPlusAndMinusSymbols($item) {
  //   $(`.tn-ticket-selector__pricetype-container[data-zone-id="${zone}"]`).find('.tn-ticket-selector__pricetype-select-wrapper').each(function () {
  //     $(this).append('<div class="c-pricetype-button c-pricetype-button--increase">+</div><div class="c-pricetype-button c-pricetype-button--decrease">-</div>')
  //   })
  // }

  // // Adds selected tag to parent li
  // $('input[type=radio]:checked.tn-ticket-selector__input-zone').parent().addClass('selected')
  // // Add incremental buttons to pricetype containers without timed entry e.g. Typhoon Force
  // if ($('.tn-ticket-selector__pricetype-container').css('display') !== 'none') {
  //   // This could be cleaner and use the addPlusAndMinusSymbols funtion
  //   $(this).find('.tn-ticket-selector__pricetype-select-wrapper').each(function () {
  //     $(this).append('<div class="c-pricetype-button c-pricetype-button--increase">+</div><div class="c-pricetype-button c-pricetype-button--decrease">-</div>')
  //   })
  // }

  // // Timed Entry - Appends pricing table and incremental buttons only once
  // $(inputZone).on('change', function () {
  //   zone = $(this).data('zone-id')

  //   addPlusAndMinusSymbols($(this))
  // })

  // // Incremenal buttons add value to dropdowns
  // $('.tn-ticket-selector__controls-container').on('click', '.c-pricetype-button', function () {
  //   const select = $(this).parent().find('select')
  //   let value = parseFloat(select.val())

  //   if ($(this).text() === '+') {
  //     value++
  //   } else if (value > 0) {
  //     // Value can't go below zero
  //     value--
  //   }

  //   if (value) {
  //     $('#tn-add-to-cart-button').removeAttr('disabled')
  //   } else {
  //     $('#tn-add-to-cart-button').attr('disabled', 'disabled')
  //   }

  //   select.val(value)
  // })

  // eslint-disable-next-line no-unused-vars
  let pricingTable
  $(inputZone).click(function () {
    $(this).parents('li')
      .addClass('selected')
      .siblings()
      .removeClass('selected')
    zone = $(this).data('zone-id')
    $('#c-custom-table').remove()

    pricingTable = new PricingTable(zone)

    // Get Session Data Layer
    const session = dataLayer.find(function (e) { return e.hasOwnProperty("session"); }).session;
    // Pull Mode Of Sale
    const modeOfSale = session.modeOfSale;

    if ((modeOfSale == 43) || (modeOfSale == 54) || (modeOfSale == 63)) {
      $('.c-pricing-table__adult.passholder').show();
      $('.c-pricing-table__child.passholder').show();
    }

//Hide Sold Out Zones
          $('.tn-ticket-selector__sold-out-section-heading').hide();
          $('.tn-ticket-selector__sold-out-zones').hide();
    
  // Pictureville Members free tickets

   if (modeOfSale != 38) {
      $('.c-pricing-table__Cinema.Free.Ticket').hide();
    }
    
    // $('html, body').delay(350).animate({
    //   scrollTop: $('#instructions-choose-zone').offset().top - $('#site-header').height()
    // }, 500)
  })

  // Simple table when not using timed entry
  if ($('#tn-events-detail-best-available-form > div.tn-ticket-selector__controls-container > fieldset.tn-ticket-selector__zone-selector > ul > li').length <= 1) {
    new PricingTable(inputZone.data('zone-id'), false)
  }

  // Add disabled tag to parent li
  $('input[type=radio]:disabled.tn-ticket-selector__input-zone').parents('li').addClass('disabled')

  // When event calender has loaded, check for unavaliable events and add class
  // This needs a more sophiticated solution
  const interval = setInterval(function () {
    let $children
    $('.tn-events-calendar__event').each(function () {
      $children = $(this).children().find('.tn-events-calendar__event-status:contains("Sorry!")')
      console.log($children.length)
      if ($children.length) {
        $(this).addClass('unavaliable')
      }
      clearInterval(interval)
    })
  }, 1000)

  //
  // Reorganise mailing list signup checkboxes
  //

  const siteName = '#siteName'

  if ($('body').hasClass('account-create') || $('body').hasClass('account-interests') || $('body').hasClass('account-create-brief')) {
    $('.tn-interests .form-group .control-label').html('<legend class="js-interests-form__heading c-fieldset__title">Please let us know which of the following you are interested in:</legend>')
    // build sections for different signup categories
    $('.tn-interests .form-group').attr('id', 'js-interests-form')

    if ($(siteName).hasClass('mus-science')) {

      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--shop', 'Shop'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [$('.tn-interest-99-label'), $('.tn-interest-98-label'), $('.tn-interest-100-label'), $('.tn-interest-267-label')]
      const shopSection = [$('.tn-interest-95-label'), $('.tn-interest-97-label'), $('.tn-interest-96-label')]
      const educationSection = [$('.tn-interest-92-label'), $('.tn-interest-93-label'), $('.tn-interest-94-label')]
      const exhibitionSection = [$('.tn-interest-88-label'), $('.tn-interest-89-label'), $('.tn-interest-90-label'), $('.tn-interest-91-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--shop', shopSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'The Science Museum'
      $('.tn-interest-102-label').parent().hide() // Hide Science Museum Checkbox
      var museumSignup = [$('.tn-interest-689-label'), $('.tn-interest-687-label'), $('.tn-interest-168-label'), $('.tn-interest-156-label'), $('.tn-interest-157-label'), $('.tn-interest-213-label')]

    } else if ($(siteName).hasClass('mus-industry')) {

      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--support', 'Support'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [$('.tn-interest-100-label'), $('.tn-interest-179-label'), $('.tn-interest-204-label')]
      const supportSection = [$('.tn-interest-268-label')]
      const educationSection = [$('.tn-interest-172-label'), $('.tn-interest-173-label'), $('.tn-interest-174-label'), $('.tn-interest-175-label'), $('.tn-interest-176-label')]
      const exhibitionSection = [$('.tn-interest-169-label'), $('.tn-interest-170-label'), $('.tn-interest-171-label'), $('.tn-interest-731-label'), $('.tn-interest-732-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--support', supportSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'The Science and Industry Museum'
      $('.tn-interest-168-label').parent().hide() // Hide Museum of Science & Industry Checkbox
      var museumSignup = [$('.tn-interest-689-label'), $('.tn-interest-687-label'), $('.tn-interest-156-label'), $('.tn-interest-157-label'), $('.tn-interest-213-label'), $('.tn-interest-102-label')]

    } else if ($(siteName).hasClass('mus-mediamus')) {

      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--support', 'Support'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [$('.tn-interest-100-label'), $('.tn-interest-540-label'), $('.tn-interest-733-label')]
      const supportSection = [$('.tn-interest-149-label'), $('.tn-interest-266-label')]
      const educationSection = [$('.tn-interest-146-label'), $('.tn-interest-147-label'), $('.tn-interest-148-label'), $('.tn-interest-616-label')]
      const exhibitionSection = [$('.tn-interest-143-label'), $('.tn-interest-144-label'), $('.tn-interest-145-label'), $('.tn-interest-313-label'), $('.tn-interest-314-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--support', supportSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'The National Science and Media Museum'
      $('.tn-interest-156-label').parent().hide() // Hide National Science & Media Museum Checkbox
      var museumSignup = [ $('.tn-interest-689-label'), $('.tn-interest-687-label'), $('.tn-interest-168-label'), $('.tn-interest-157-label'), $('.tn-interest-213-label'), $('.tn-interest-102-label')]

    } else if ($(siteName).hasClass('mus-railway')) {

      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--shop', 'Shop'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [ $('.tn-interest-624-label'), $('.tn-interest-100-label'), $('.tn-interest-167-label'), $('.tn-interest-270-label')]
      const shopSection = [$('.tn-interest-164-label'), $('.tn-interest-165-label'), $('.tn-interest-166-label')]
      const educationSection = [$('.tn-interest-160-label'), $('.tn-interest-161-label'), $('.tn-interest-162-label'), $('.tn-interest-163-label')]
      const exhibitionSection = [$('.tn-interest-158-label'), $('.tn-interest-188-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--shop', shopSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'The National Railway Museum'
      $('.tn-interest-157-label').parent().hide() // Hide Museum of Science & Industry Checkbox
      var museumSignup = [ $('.tn-interest-689-label'), $('.tn-interest-687-label'), $('.tn-interest-168-label'), $('.tn-interest-156-label'), $('.tn-interest-213-label'), $('.tn-interest-102-label')]
    
    } else if ($(siteName).hasClass('mus-locomotion')) {

      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--shop', 'Shop'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [$('.tn-interest-269-label')]
      const shopSection = [$('.tn-interest-222-label')]
      const educationSection = [$('.tn-interest-221-label')]
      const exhibitionSection = [$('.tn-interest-220-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--shop', shopSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'Locomotion'
      $('.tn-interest-213-label').parent().hide() // Hide Locomotion Checkbox
      var museumSignup = [$('.tn-interest-689-label'), $('.tn-interest-687-label'), $('.tn-interest-168-label'), $('.tn-interest-156-label'), $('.tn-interest-157-label'), $('.tn-interest-102-label')]
    
    } else if ($(siteName).hasClass('mus-sip')) {
      
      // Topic-led Preferences
      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--support', 'Support'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }

      const otherSection = [$('.tn-interest-691-label')]
      const supportSection = [$('.tn-interest-692-label')]
      const exhibitionSection = [$('.tn-interest-690-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--support', supportSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
      // Museum-led preferences
      var museumName = 'Science & Innovation Park'
      $('.tn-interest-689-label').parent().hide() // Hide SIP Checkbox
      var museumSignup = [$('.tn-interest-689-label'), $('.tn-interest-156-label'), $('.tn-interest-168-label'), $('.tn-interest-213-label'), $('.tn-interest-157-label'), $('.tn-interest-102-label')]

    } else {

      const signupSections = [['c-signup-section--other', 'Other'], ['c-signup-section--support', 'Support'], ['c-signup-section--education', 'Education'], ['c-signup-section--events', 'Exhibitions &amp; Events']]
      for (let i = signupSections.length; i--;) {
        $('#js-interests-form').append(signupSections[i] = '<fieldset class="' + signupSections[i][0] + ' c-signup-section"><legend class="c-fieldset__title">' + signupSections[i][1] + '</legend></fieldset>')
      }
      const otherSection = [$('.tn-interest-99-label'), $('.tn-interest-98-label'), $('.tn-interest-100-label'), $('.tn-interest-267-label')]
      const shopSection = [$('.tn-interest-95-label'), $('.tn-interest-97-label'), $('.tn-interest-96-label')]
      const educationSection = [$('.tn-interest-92-label'), $('.tn-interest-93-label'), $('.tn-interest-94-label')]
      const exhibitionSection = [$('.tn-interest-88-label'), $('.tn-interest-89-label'), $('.tn-interest-90-label'), $('.tn-interest-91-label')]
      const interestsSections = [['.c-signup-section--other', otherSection], ['.c-signup-section--shop', shopSection], ['.c-signup-section--education', educationSection], ['.c-signup-section--events', exhibitionSection]]
      for (let i = interestsSections.length; i--;) {
        $(interestsSections[i][1]).each(function () {
          // get parent of element (checkbox)
          $(this).parent().appendTo(interestsSections[i][0])
        })
      }
    }
    // build section for museum email section
    const museumPreferences = function () {
      $('#js-interests-form').after(`
        <div id="js-museum-form">
        <p>${museumName} is part of the Science Museum Group.</p>
        <fieldset class="form-group form-group--smg">
        <legend class="js-interests-form__heading c-fieldset__title">I would like to receive emails about events, fundraising and activities at:</legend>
        </fieldset>
        </div>`
      )
      // define the relevent labels, append the parent (checkbox) of each one into the section
      for (let i = museumSignup.length; i--;) {
        $(museumSignup[i]).each(function () {
          $(this).parent().appendTo('.form-group--smg')
        })
      }
    }
    museumPreferences()

  }


  //
  // Master Checkbox for mailing list preferences
  //

  const masterCheckbox = function () {
    // Remove L, Y, B, M prefixes from checkboxes
    $('#js-interests-form .checkbox>label').each(function () {
      const text = $(this).html().trim()
        .replace(/([S|L|M|B|Y|W] )(.*)/g, '$2')
      $(this).html(text)
    })
    $('#js-museum-form .checkbox>label').each(function () {
      const text = $(this).html().trim()
        .replace(/(S Museum Email)(.*)/g, 'Locomotion, Shildon $2')
        .replace(/(L Museum Email)(.*)/g, 'Science Museum, London $2')
        .replace(/(M Museum Email)(.*)/g, 'Science &amp; Industry Museum, Manchester $2')
        .replace(/(B Museum Email)(.*)/g, 'National Science &amp; Media Museum, Bradford $2')
        .replace(/(Y Museum Email)(.*)/g, 'National Railway Museum, York $2')
        .replace(/(W Museum Email)(.*)/g, 'Science and Innovation Park, Wroughton $2')        
      $(this).html(text)
    })

    //
    // Define the event checkbox that needs to be ticked when the master checkbox is ticked
    //
    const eventCheckboxData = [
      { 'checkbox': 102, 'class': 'mus-science', 'museumName': 'Science Museum' },
      { 'checkbox': 168, 'class': 'mus-industry', 'museumName': 'Science and Industry Museum' },
      { 'checkbox': 156, 'class': 'mus-mediamus', 'museumName': 'National Science and Media Museum' },
      { 'checkbox': 157, 'class': 'mus-railway', 'museumName': 'National Railway Museum' },
      { 'checkbox': 213, 'class': 'mus-locomotion', 'museumName': 'Locomotion' },
      { 'checkbox': 689, 'class': 'mus-sip', 'museumName': 'Science and Innovation Park' }
    ]
    const defineCheckbox = function () {
      $.each(eventCheckboxData, function (i, item) {
        if ($(siteName).hasClass(eventCheckboxData[i].class)) {
          const eventCheckbox = $(`#checkbox-options-${eventCheckboxData[i].checkbox}`)
          $(eventCheckbox).prop('checked', true)
        } else {
          const eventCheckbox = $('#checkbox-options-102')
          $(eventCheckbox).prop('checked', true)
        }
      })
    }
    const masterCheckboxLabel = function () {
      $.each(eventCheckboxData, function (i, item) {
        if ($(siteName).hasClass(eventCheckboxData[i].class)) {
          const eventCheckbox = $(`#checkbox-options-${eventCheckboxData[i].checkbox}`)
          $('.tn-interests h2').after(`<div class="checkbox checkbox--master" id="checkbox--master"></div>`)
          eventCheckbox.parent().appendTo('#checkbox--master')
          if ($(siteName).hasClass('mus-locomotion')) {
            $('#checkbox--master label').contents().eq(1).replaceWith(`I would like to receive emails about ${eventCheckboxData[i].museumName}\'s events, fundraising and activities.`)
          } else {
            $('#checkbox--master label').contents().eq(1).replaceWith(`I would like to receive emails about the ${eventCheckboxData[i].museumName}\'s events, fundraising and activities.`)
          }
        }
      })
    }
    masterCheckboxLabel()

    //
    // Append disclaimer to mailing list preferences
    //
    const disclaimerText = function () {
      $.each(eventCheckboxData, function (i, item) {
        if ($(siteName).hasClass(eventCheckboxData[i].class)) {
          if ($(siteName).hasClass('mus-locomotion')) {
            const disclaimerString = `<div id="js-disclaimer"><div class="form-group form-group--disclaimer"><p>To sign up to receive emails you must be aged 16 or over.</p><p>Your information will be processed for administration, marketing and charitable purposes in accordance with our Privacy Notice, the UK General Data Protection Regulation (UK GDPR) and any related data protection laws applicable in the UK. We will not share your personal details without your consent nor email you about our events, fundraising and activities unless you choose to hear from us. If you have any questions regarding the use of your data, please read our <a href="https://group.sciencemuseum.org.uk/privacy">Privacy Notice</a> or <a href="mailto:data.protection@sciencemuseum.ac.uk">contact us</a>. ${eventCheckboxData[i].museumName} is part of the Science Museum Group.</p></div></div>`
            $('#js-museum-form').after(disclaimerString)
          } else {
            const disclaimerString = `<div id="js-disclaimer"><div class="form-group form-group--disclaimer"><p>To sign up to receive emails you must be aged 16 or over.</p><p>Your information will be processed for administration, marketing and charitable purposes in accordance with our Privacy Notice, the UK General Data Protection Regulation (UK GDPR) and any related data protection laws applicable in the UK. We will not share your personal details without your consent nor email you about our events, fundraising and activities unless you choose to hear from us. If you have any questions regarding the use of your data, please read our <a href="https://group.sciencemuseum.org.uk/privacy">Privacy Notice</a> or <a href="mailto:data.protection@sciencemuseum.ac.uk">contact us</a>. The ${eventCheckboxData[i].museumName} is part of the Science Museum Group.</p></div></div>`
            $('#js-museum-form').after(disclaimerString)
          }
        }
      })
    }
    disclaimerText()

    //
    // Add Master checkbox, and define the effects on the other checkboxes it should have
    //
    const interestCheckboxes = '.c-signup-section .checkbox input'
    const interestLabel = '.c-signup-section .checkbox label'
    //
    // Check if event checkbox is already checked.
    //
    const checkCheckbox = function () {
      $.each(eventCheckboxData, function (i, item) {
        if ($(siteName).hasClass(eventCheckboxData[i].class)) {
          const masterCheckbox = '#checkbox--master input'
          if ($(masterCheckbox).is(':checked')) {
            //
            // If it's checked make sure nothing is disabled, and check the master checkbox
            //
            $(interestCheckboxes).removeAttr('disabled', true)
            $(interestLabel).removeClass('js-disabled')
          } else {
            //
            // If it isn't disable the checkboxes and listen out for click events
            //
            $(interestCheckboxes).prop('checked', false)
            $(interestCheckboxes).attr('disabled', true)
            $(interestLabel).addClass('js-disabled')
          }
          $(masterCheckbox).click(function () {
            if (this.checked === true) {
              //
              // if master checkbox is checked, enable inputs
              //
              $(interestCheckboxes).removeAttr('disabled', true)
              $(interestLabel).removeClass('js-disabled')
            } else {
              //
              // if master checkbox is unchecked, disable inputs and uncheck all of them
              //
              $(interestCheckboxes).prop('checked', false)
              $(interestCheckboxes).attr('disabled', true)
              $(interestLabel).addClass('js-disabled')
            }
          })
        }
      })
    }
    checkCheckbox()

  }

  masterCheckbox()


  //
  // Define checkboxes for auto-checking
  //

  // Define opt-in box
  const scienceBox = $('#checkbox-options-102')
  // Define specific interests to auto-check
  const scienceAutoPrefs = $('#checkbox-options-267, #checkbox-options-88')
  // Check boxes on opt-in change
  scienceBox.on('change', function(){
    scienceAutoPrefs.prop('checked',this.checked);
  });

  // Define opt-in box
  const mediaBox = $('#checkbox-options-156')
  // Define specific interests to auto-check
  const mediaAutoPrefs = $('#checkbox-options-145, #checkbox-options-143, #checkbox-options-144, #checkbox-options-266')
  // Check boxes on opt-in change
  mediaBox.on('change', function(){
    mediaAutoPrefs.prop('checked',this.checked);
  });

  // Define opt-in box
  const industryBox = $('#checkbox-options-168')
  // Define specific interests to auto-check
  const industryAutoPrefs = $('#checkbox-options-169, #checkbox-options-268')
  // Check boxes on opt-in change
  industryBox.on('change', function(){
    industryAutoPrefs.prop('checked',this.checked);
  });

  // Define opt-in box
  const railwayBox = $('#checkbox-options-157')
  // Define specific interests to auto-check
  const railwayAutoPrefs = $('#checkbox-options-158, #checkbox-options-270')
  // Check boxes on opt-in change
  railwayBox.on('change', function(){
    railwayAutoPrefs.prop('checked',this.checked);
  });

  // Define opt-in box
  const locomotionBox = $('#checkbox-options-213')
  // Define specific interests to auto-check
  const locomotionAutoPrefs = $('#checkbox-options-269, #checkbox-options-220')
  // Check boxes on opt-in change
  locomotionBox.on('change', function(){
    locomotionAutoPrefs.prop('checked',this.checked);
  });

  // Define opt-in box
  const sipBox = $('#checkbox-options-689')
  // Define specific interests to auto-check
  const sipAutoPrefs = $('#checkbox-options-690, #checkbox-options-692')
  // Check boxes on opt-in change
  sipBox.on('change', function(){
    sipAutoPrefs.prop('checked',this.checked);
  });
  
  // Replace title from 'Available Sections' to 'Available Times'
  $('h3.tn-ticket-selector__heading-available-zones').each(function () {
    const text = $(this).text()
    $(this).text(text.replace('Sections', 'Times'))
  })

  // Replace label in NRM preferences
  // Because this is a text node and not an HTML element, we have to navigate the DOM
  $('label.tn-interest-624-label').contents().last().replaceWith('Flying Scotsman news & events');

  //
  // If any of the selects have more than 0 value selected, if so then enable the add to cart button
  $(document).on('change', '.tn-ticket-selector__pricetype-select', function () {
    if ($('.tn-ticket-selector__pricetype-select').filter(function () {
      return parseInt(this.value, 10) !== 0
    }).length === 0) {
      $('#tn-add-to-cart-button').attr('disabled', 'disabled')
    } else {
      $('#tn-add-to-cart-button').removeClass('disabled')
      $('#tn-add-to-cart-button').removeAttr('disabled')
      $('#tn-add-to-cart-button').removeAttr('aria-disabled')
      
      
    }
  })

  //
  // Locomotion Skin for Railway Museum
  //
  if (window.location.search.indexOf('museum=locomotion') > -1 || sessionStorage.getItem('locomotion')) {
    $(document.body).addClass('locomotion')
    $('.brand-logo-link img').attr('src', publicPath + '/img/loco-logo.svg')
    sessionStorage.setItem('locomotion', 'true')
  }

  // When select dropdown is value changed, change the value of the respective select dropdown further up in the markup
  // This is essential for the tables to work
  $(document).on('change', '.c-pricing-table--individual .tn-ticket-selector__pricetype-select', function () {
    const value = $('option:selected', this).val()
    const selectId = $(this).prop('id')

  // Hide the sold out zones  
    $('.tn-ticket-selector__sold-out-section').hide();
    
    // This takes the id of the dropdown that's changed, and applies it to the hidden select with the same id (because it appears first in the DOM)
    // Should there be two elements with the same ID? probably not
    $('#' + selectId).val(value).change()
  })


   // Added by SMG to populate gift certificate amount from drop down rather than standard input box 13/10/2023

  if  ($("[id*='Gift_Values_Select']")) {
 
    var ddl = $("[id*='Gift_Values_Select']")

    $(document).on('change', '#GiftCertificate_Gift_Values_Select', function () {

      var ddlvalue = ddl.find(":selected").text()
      var ddlfloat = ddlvalue.substring(ddlvalue.indexOf("£") + 1)
      console.log(parseFloat(ddlfloat))

      $('#AddGiftCertificate_Amount').val(parseFloat(ddlfloat))

    })

}

// Add date picker to delivery date field  
  
if ($('#GiftCertificate_Gift_Voucher_Delivery_Text').length) 
{
  $('#GiftCertificate_Gift_Voucher_Delivery_Text')[0].type = "date"
}
 


  
// Payment Plans

var isRegularGiving = false;

const paymentSchedules = function ()
{

if ($(".tn-payment-plan-selection__billing-schedule-input").length)
{
if ($(".tn-payment-plan-eligible-items__list-item-properties:contains('Pre Opening Tour')").length)

    {
        $(".tn-payment-plan-selection__billing-schedule-input").each(function(){
            if (this.value != "9")
                {
                    $(this).parent('.tn-payment-plan-selection__billing-schedule-label').hide();
                }
    });

$('.tn-payment-plan-eligible-items__description').html('Your order is eligible for a payment plan which allows you to hold your booking for the next 7 days before making payment. To select this option, please click the ‘Select This Plan’ button below.<br><br>Please note that if you choose this option, you will be automatically charged for your order after 7 days have elapsed if you do not cancel your booking.') 

}
else
    { 
       isRegularGiving = true;
       $('.tn-payment-plan-eligible-items').hide()
        $(".tn-payment-plan-selection__billing-schedule-input").each(function(){ 
            if (this.value == "9")
                {
                  $(this).parent('.tn-payment-plan-selection__billing-schedule-label').hide();
                }
    });
}
}

if (isRegularGiving)
  {
    $('.tn-cart-totals__line-item').hide()
    $('.tn-cart-totals__line-item--payment-plan-total').hide()
    $('.tn-cart-totals__line-item--deferred-amount').hide()
    $('.modal-btn-cancel').hide()
    $('.modal-header').children('.close').hide()
    $('.modal-dismiss-layer').hide()
  }

}

//Mask totals from basket only contains a regular giving product

if 
( 
  ($(".tn-cart-line-item-name:contains('Regular Giving')").length === ( $(".tn-cart-line-item-name").length)) ||
  ($(".tn-cart-item-detail__list-item--pricetype:contains('Regular Giving')").length === ( $(".tn-cart-line-item-name").length)) 
)
{
  $('.tn-cart-item-summary__property--date-time').hide()  
  $('.tn-cart-item-summary__property--price-total').hide()
  $('.tn-cart-item-detail__list-item--price').hide()
  $('.tn-payment-plan-summary').hide()
  $('.tn-cart-totals').hide()
  $('.tn-cart-totals__section').hide()
  $('.tn-patron-shipping-information').hide()
  $('.tn-payment-apply-gift-certificate').hide()
  $('.tn-cart-totals__line-item--ineligible-items-subtotal').hide()
  $('.tn-cart-item-summary__property--location').hide()
  $('.tn-cart-item-detail__list-item--description').hide()

  //Hide options to remove the schedule
  $('.modal-btn-cancel').hide()
  $('.tn-cart-applied-payment-plan__btn-remove').hide()
  $('.tn-cart-applied-payment-plan__btn-view-details').hide()


  $('.tn-cart-payment-plan__description').html("<p>Thank you for making a monthly donation. To review or amend your Payment Plan, please use the buttons below.</p> <p>You can change or cancel your monthly donation at any time by simply contacting <a href='info@sciencemuseumgroup.ac.uk'>info@sciencemuseumgroup.ac.uk</a> or calling 033 0058 0058.</p> <p><strong>Important Notice:</strong> Please note that if you are making a monthly donation, you will need to remove any additional items currently in your basket. You will need to complete your monthly donation order first, before starting a new order for any further purchases. Thank you for your understanding.</p>")

  if($('body').hasClass('cart') && $('body').hasClass('receipt') )
    {
      $('.tn-heading-sub-text').hide()
    }


}

// Pre Opening Tour - hide individual tickets as we charge per group

if ( $(".tn-cart-line-item-name:contains('Pre Opening Tour')").length === ( $(".tn-cart-line-item-name").length))
  {
    $('.tn-cart-item-detail__list').hide()

    $('.tn-cart-payment-plan__description p:first').text("Your order is eligible for a payment plan, which allows you to hold your booking for the next 7 days before making payment. To select this option, please click the 'Select Payment Plan' button below.")

  }


//Automatically Trigger Select Schedule if its a regular giving order

$(".tn-cart-item-detail__list-item--pricetype").each(function(){

  var prodName = $(this).text();
  if ((prodName.toLowerCase().indexOf("adopt an object") >= 0) || (prodName.toLowerCase().indexOf("regular giving") >= 0))
  {
  $(".tn-payment-plan-selection__btn-select-plan").trigger('click');
  }

})




//To target the payment plan modal we need to use MutationObserver 


if ($(".tn-cart-payment-plan__actions").length)

{

  const targetPage =  document.getElementsByClassName('cart-payment')[0];

// Options for the observer (which mutations to observe)
const config = { childList: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      paymentSchedules();
    } 
 
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetPage, config);

}

//   Change delivery text to gift vouchers
if ($(".tn-cart-line-item-name:contains('Gift Voucher')").length === ( $(".tn-cart-line-item-name").length))  
 {
    $(".tn-selected-shipping-method").text("Voucher sent by email")
 }
  

  
  
})

// Next Avaiable Extension
import nextAvailable from './customisations/next-available'
// Dynamic copy based on URL params
import copyByUrlParam from './customisations/copy-by-url-param'


